'use strict';

var FaresToolbarController = function FaresToolbarController($rootScope, $scope, searchCriteriaConstantsService, FaresConstants) {
  $scope.screen = searchCriteriaConstantsService.FARES;
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.isSearchButtonVisible = function () {
    return $scope.selectedBookmark === FaresConstants.SCREEN_VALUE.FARE_ANALYSIS;
  };
  $scope.bookmarks = [{
    label: 'Fares',
    value: FaresConstants.SCREEN_VALUE.FARE_ANALYSIS,
    component: FaresConstants.SCREEN_VALUE.FARE_ANALYSIS
  }, {
    label: 'Adjustments',
    value: FaresConstants.SCREEN_VALUE.ADJUSTMENTS,
    component: FaresConstants.SCREEN_VALUE.FARE_ANALYSIS
  }];
  $scope.$watch('selectedBookmark', function () {
    $rootScope.$broadcast('fares:modeChanged', $scope.selectedBookmark);
  });
  $scope.selectedBookmark = FaresConstants.SCREEN_VALUE.FARE_ANALYSIS;
};
FaresToolbarController.$inject = ['$rootScope', '$scope', 'SearchCriteriaConstantsService', 'FaresConstants'];
module.exports = FaresToolbarController;